import script from "./Goods.vue?vue&type=script&setup=true&lang=js"
export * from "./Goods.vue?vue&type=script&setup=true&lang=js"

import "./Goods.vue?vue&type=style&index=0&id=19edd57d&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3689317901/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-prod-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19edd57d"]])

export default __exports__